import React from "react";
import { useStore } from "../../../../stores/store";

const Polygon = () => {
  const formElementStyle = "flex items-center my-2";
  const labelElementStyle = "text-md mr-3 w-1/2 flex-1 text-right";
  const inputElementStyle =
    "border border-gray-300 rounded-md p-0.5 w-1/2 text-md";
  const {
    markupFillStyle,
    setMarkupFillStyle,
    markupFillColor,
    setMarkupFillColor,
    markupPolygonOutlineStyle,
    setMarkupPolygonOutlineStyle,
    markupPolygonOutlineWidth,
    setMarkupPolygonOutlineWidth,
    markupPolygonOutlineColor,
    setMarkupPolygonOutlineColor,
  } = useStore();
  return (
    <>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Style:</label>
        <select
          className={inputElementStyle}
          value={markupFillStyle}
          onChange={(e) => setMarkupFillStyle(e.target.value)}
        >
          <option value="backward diagonal">backward diagonal</option>
          <option value="cross">cross</option>
          <option value="diagonal cross">diagonal cross</option>
          <option value="forward diagonal">forward diagonal</option>
          <option value="horizontal">horizontal</option>
          <option value="none">none</option>
          <option value="solid">solid</option>
          <option value="vertical">vertical</option>
        </select>
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Color:</label>{" "}
        <input
          value={markupFillColor}
          onChange={(e) => setMarkupFillColor(e.target.value)}
          className={inputElementStyle}
          type="color"
        />
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Outline Style:</label>{" "}
        <select
          className={inputElementStyle}
          value={markupPolygonOutlineStyle}
          onChange={(e) => setMarkupPolygonOutlineStyle(e.target.value)}
        >
          <option value="dash">dash</option>
          <option value="dash dot">dash dot</option>
          <option value="dash dot dot">dash dot dot</option>
          <option value="dot">dot</option>
          <option value="none">none</option>
          <option value="short dash dot dot">short dash dot dot</option>
          <option value="solid">solid</option>
        </select>
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Outline Width:</label>{" "}
        <input
          type="number"
          className={inputElementStyle}
          value={markupPolygonOutlineWidth}
          onChange={(e) => setMarkupPolygonOutlineWidth(Number(e.target.value))}
        />
      </div>
      <div className={formElementStyle}>
        <label className={labelElementStyle}>Outline Color:</label>{" "}
        <input
          className={inputElementStyle}
          type="color"
          value={markupPolygonOutlineColor}
          onChange={(e) => setMarkupPolygonOutlineColor(e.target.value)}
        />
      </div>
    </>
  );
};

export default Polygon;
